import type { Space } from '@cocoonspace/sdk-js/types/space'
import { useMemo } from 'react'

export const useSpaceAddress = (
	space?: Pick<Space, 'address'>,
	dense?: boolean,
) => {
	const fullAddress = useMemo(() => {
		const address = []

		address.push(space?.address?.address1)

		if (space?.address?.address2 && !dense) {
			address.push(space?.address?.address2)
		}

		address.push(`${space?.address?.postal_code} ${space?.address?.city}`)

		return address.join(', ')
	}, [space, dense])

	return {
		fullAddress,
	}
}
